import React, { useCallback } from 'react';
import { withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';

import { showModal } from 'actions/modal';

import { useGetCurrentPlanProps } from 'shared-hooks/team';
import { useIsBillingOwner } from 'shared-hooks/billing';
import { trackEvent } from 'services/events-tracker-service';

const PlanUpgradeButton = ({ reason, uppercase, onClick, children, history, location, t }) => {
    const currentPlanProps = useGetCurrentPlanProps();
    const isBillingOwner = useIsBillingOwner();

    const handleClick = useCallback(type => {
        onClick && onClick();

        trackEvent('PLAN_QUOTA_REACHED_UPGRADE.CLICK', { type: reason });

        if (currentPlanProps?.appSumo) {
            history.push({
                pathname: `/settings/team/current/billing`,
                state: {
                    closeUrl: location?.pathname
                } 
            });

            return;
        }

        showModal('SWITCH_PLAN');
    }, [currentPlanProps?.appSumo, reason, history, location?.pathname]);

    const transformText = useCallback(input => {
        if (!uppercase) {
            return input.charAt(0).toLowerCase() + input.slice(1);
        }

        return input;
    }, [uppercase]);

    if (isBillingOwner) {
        return <button className="btn btn-link btn-link-bold btn-link-underlined btn-text-warning" onClick={handleClick}>{ children || transformText(t('Upgrade')) }</button>;
    }

    return transformText(t('contactOwnerToUpgrade'));
}

export default withRouter(withTranslation('billing')(PlanUpgradeButton));
